import React, { useState } from 'react';
import { useDispatch } from "react-redux";
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import ico_loading from './../../../../assets/icons/ico_loading.gif';
import { getMsakedEmail, getMsakedCelphone } from '../../../../lib/utils/utilitarios';
import ButtonComponent from '../../../../components/button/button_component';
import { postEnviarCorreo, postEnviarSMS, setTipoEnvio } from '../../../../redux/reducers/verifyCodeSlice';
import NotificationComponent from '../../../../components/notification/notification_component';
import InputRadioSelectComponent from '../../../../components/inputRadioSelect/inputRadioSelect_component';
import cn from '../../../../lib/bem';
import { CONTENT_PAG } from '../../constants/content_pag';

import './verificacion.scss';

const Verificacion = ({mostrarFormularioEdicion}) => {
    
    const classes  = cn("verificacion");

    const dispatch = useDispatch();

    const userinfo = JSON.parse(sessionStorage.getItem("infoUsuario"));

    const [ tipoEnvio, seleccionarTipoEnvio ] = useState('0');
    const [ mensajeError, setMensajeError] = useState("");
    const [ cargandoProd, setCargandoProd ] = useState(false);

    const btnEnviarCodigoVerificacion = () => {

        setCargandoProd(true);

        if( tipoEnvio === '1' ){
            dispatch(postEnviarCorreo({
                "correo": userinfo.correo,
                "nombre": userinfo.nombre,
                "titulo": "Finalización de plazo de póliza"
            })).then( res => { 
                showResult(res);
            });
        } else {
            dispatch(postEnviarSMS({
                "telefono": userinfo.celular,
            })).then( res => { 
                showResult(res);
            });
        }
       
    }

    const showResult = (res) => {
        if( res.payload.datos.codigo === '01' ){
            dispatch(setTipoEnvio(tipoEnvio));
            mostrarFormularioEdicion(CONTENT_PAG.PAG_VERC);
        } else {
            seleccionarTipoEnvio('0');
            dispatch(setTipoEnvio(tipoEnvio));
            setMensajeError(res.payload.datos.descripcion);
        }
        setCargandoProd(false);
    }
 
    return (
        <div className={classes()}>
            <p className={classes('titleConfEdit')}><b>Recibe el c&oacute;digo de verificaci&oacute;n</b></p>
            <p className={classes('descrConfEdit')}>Por tu seguridad, para poder continuar con el proceso te enviaremos un c&oacute;digo por el medio que desees.</p>
            <br/>
            <div className={classes('divSelectVerificacion')}>
                <InputRadioSelectComponent text={`Enviar mail a ${getMsakedEmail(userinfo.correo)}`} checked={tipoEnvio} valor={'1'} accion={ () => seleccionarTipoEnvio('1')} nombreRadio={'tipoEnvio'}/>
                <InputRadioSelectComponent text={`Enviar SMS a ${getMsakedCelphone(userinfo.celular)}`}  checked={tipoEnvio} valor={'2'} accion={ () => seleccionarTipoEnvio('2')} nombreRadio={'tipoEnvio'}/>
            </div>
            <p className={classes('descrConfEdit2')}>Si necesitas actualizar tus datos de contacto,<br/>comun&iacute;cate al <a className={classes('linkTel')} href="tel:015135000">(01) 513 5000</a></p>
            <div className={classes('btnContinuar')}>
                {
                    cargandoProd ? 
                        <img src={ico_loading} alt='cargando' />  
                    :
                        <ButtonComponent label={'btnContinuar'} nombre={'Continuar'} tipo={'button-red'} action={() => btnEnviarCodigoVerificacion()} disabled={tipoEnvio==='0'} />
                }
                
            </div>
            {
                mensajeError !== "" ?
                    <NotificationComponent faIcon={faTimes} textNotification={mensajeError} tipo="error"/>
                : null
            }
        </div>
    );
};

export default Verificacion;
